import {
  CompanyPageSourceDerivedSectionAttributes,
  CustomSectionNode,
  CustomSectionNodeType,
  CustomSectionType,
  PeoplePageSourceDerivedQuestionSectionAttributes,
  PeoplePageSourceDerivedSignalSectionAttributes,
} from 'api/custom-section/types';
import { JSONContent } from 'api/page-template/types';

export const isCustomSectionNode = (
  node: JSONContent,
): node is CustomSectionNode => {
  return node.type === CustomSectionNodeType.RlCustomSection;
};
export const isCompanyPageSourceDerivedSection = (
  node: CustomSectionNode,
): node is CustomSectionNode<CompanyPageSourceDerivedSectionAttributes> => {
  return (
    node.attrs.sectionType === CustomSectionType.CompanyPageSourceDerivedSection
  );
};
export const isPeoplePageSourceDerivedSignalSection = (
  node: CustomSectionNode,
): node is CustomSectionNode<PeoplePageSourceDerivedSignalSectionAttributes> => {
  return (
    node.attrs.sectionType ===
    CustomSectionType.PeoplePageSourceDerivedSignalSection
  );
};
export const isPeoplePageSourceDerivedQuestionSection = (
  node: CustomSectionNode,
): node is CustomSectionNode<PeoplePageSourceDerivedQuestionSectionAttributes> => {
  return (
    node.attrs.sectionType ===
    CustomSectionType.PeoplePageSourceDerivedQuestionSection
  );
};
